import React from 'react';

export const defaultFlags = {
  Read: false,
  Write: false,
  Visible: false
};

export const superFlags = {
  Read: true,
  Write: true,
  Visible: true
};

const userRights = {};
const checkUserRights = (id = '', prop = '', checkVisibility = false) => false;

export const UserRightsContext = React.createContext({
  isSuper: false,
  userRights,
  checkUserRights
});
